/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_MuteInputs */

const en_playbar_mute = /** @type {(inputs: Playbar_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mute`)
};

const es_playbar_mute = /** @type {(inputs: Playbar_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silenciar`)
};

/**
* | output |
* | --- |
* | "Mute" |
*
* @param {Playbar_MuteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_mute = /** @type {((inputs?: Playbar_MuteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_MuteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_mute(inputs)
	return en_playbar_mute(inputs)
});